export const CUSTOMER_SEND_MESSAGE = "sacUserData/CUSTOMER_SEND_MESSAGE";
export const CUSTOMER_SEND_FAILED = "sacUserData/CUSTOMER_SEND_FAILED";
export const CUSTOMER_SEND_SUCCESS = "sacUserData/CUSTOMER_SEND_SUCCESS";